module.exports = __webpack_public_path__ + "static/media/huawei-app-gallery-badge.1a93a365.png";